// extracted by mini-css-extract-plugin
export default {"question":"_7a84dee8","questionHeader":"_5fbdc637","questionTitle":"_32474168","answerCount":"_e51ce2f9","button":"_e0ff4170","ampExpandableCollapsed":"_c43ed999"};